export default __webpack_public_path__ + "static/media/pickup-icon.52915d27.svg";